export enum AlertType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
}

export enum AlertIconType {
  info = 'info',
  success = 'check-circle',
  warning = 'warning',
  danger = 'error-outline',
}
